import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PERSONALIZED_STICKY_FOOTER_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5361_v1_personalized_sticky_footer'

export const i18nInstance = registerI18nResources({
  namespace: PERSONALIZED_STICKY_FOOTER_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
